const prod = {
  url: {
    API_URL: "https://cool-api-new.ogwebdesign.ca/api/",
    STORAGE_URL: "https://cool-api-new.ogwebdesign.ca/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    ETHERNET_PRINTER_1_URL: "http://192.168.2.184:9100",
    ETHERNET_PRINTER_2_URL: "http://192.168.2.185:9100",
    NAME: "CAMPAIGNS - SOLMAZ FOODS",
  },
};

const stg = {
  url: {
    API_URL: "https://campaigns-demo-api.qatrace.com/api/",
    STORAGE_URL: "https://campaigns-demo-api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    ETHERNET_PRINTER_1_URL: "http://192.168.2.184:9100",
    ETHERNET_PRINTER_2_URL: "http://192.168.2.185:9100",
    NAME: "CAMPAIGNS - SOLMAZ FOODS - SANDBOX",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8000/api/",
    PRINTER_URL: "http://127.0.0.1:5003",
    NAME: "CAMPAIGNS - SOLMAZ FOODS - DEV",
    ETHERNET_PRINTER_1_URL: "http://192.168.2.184:9100",
    ETHERNET_PRINTER_2_URL: "http://192.168.2.185:9100",
  },
};

// Determine which config to use based on environment
let selectedConfig;
if (process.env.NODE_ENV === "development") {
  selectedConfig = dev;
} else {
  // In production builds, check REACT_APP_ENV to choose between prod and stg
  const buildEnv = process.env.REACT_APP_ENV;
  selectedConfig = buildEnv === "stg" ? stg : prod;
}

export const config = selectedConfig;
